import { defineStore } from 'pinia';
import { computed } from 'vue';
import { store } from '/@/store';
import { apis } from '/@/apis';
import { dictStore } from './dict';

interface PermissionState {
  permCodeList: string[] | number[];
  promptWordsEnabled: boolean;
}

export const usePermissionsStore = defineStore({
  id: 'permissions',
  state: (): PermissionState => ({
    permCodeList: [] as string[],
    promptWordsEnabled: false,
  }),
  getters: {
    getPermCodeList(): string[] | number[] {
      return this.permCodeList;
    },
  },
  actions: {
    setPermCodeList(codeList: string[]) {
      this.permCodeList = codeList;
    },

    async changePermissionCode() {
      const { getPermissions } = apis.users;
      const codeList = await getPermissions();
      this.setPermCodeList(codeList);
    },

    setPromptWordsEnabled(enabled: boolean) {
      this.promptWordsEnabled = enabled;
    },

    async syncPromptWordsPermission(userId?: string) {
      if (!userId) {
        this.setPromptWordsEnabled(false);
        return;
      }
      const whitelist = await dictStore(store).getPromptWordsWhitelist();
      this.setPromptWordsEnabled(!!whitelist?.includes(userId));
    },

    hasPermission(code: string) {
      if (code === 'promptWords') {
        return computed(() => this.promptWordsEnabled);
      }
      return computed(() => !!this.permCodeList.find((v) => v === code));
    },
  },
});

// Need to be used outside the setup
// 需要在设置之外使用
export function usePermissionsStoreWithOut() {
  return usePermissionsStore(store);
}
